import BannedBanner from '@/components/member/BannedBanner';
import ReferralLinkBox from '@/components/member/ReferralLinkBox';
import AdCreditsCard from '@/components/member/widgets/AdCreditsCard';
import DualWalletCards from '@/components/member/widgets/DualWalletCards';
import GettingStartedSection from '@/components/member/widgets/GettingStartedSection';
import PayoutProofCTA from '@/components/member/widgets/PayoutProofCTA';
import PositionStatsStrip from '@/components/member/widgets/PositionStatsStrip';
import ProfitBadge from '@/components/member/widgets/ProfitBadge';

/**
 * Dashboard — the "fruits of labor" page. PURE celebration content,
 * no utility widgets, no forms, no transactional buttons.
 *
 * Layout (top to bottom):
 *   0. ProfitStatusBadge     — v17.6 sub-pack requirement warning strip
 *                              (In Profit → green: "keep subpack active";
 *                               Not in Profit → neutral: "subpack not required")
 *   1. PayoutProofCTA        — payout screenshot proof CTA
 *   2. GettingStartedSection — onboarding cards (auto-hides for god
 *      account & once all 3 steps are complete). DASHBOARD ONLY.
 *   3. ProfitBadge           — the hero (net profit, big & screenshot-worthy)
 *   4. PositionStatsStrip    — bragging stats (lifetime / active / cycled)
 *   5. AdCreditsCard         — 1SC3 Ad Credits balance (reward currency)
 *   6. DualWalletCards       — 3 read-only balance tiles
 *   7. ReferralLinkBox       — personal referral asset
 */
const DashboardSubpage = ({ me, onNavigate }) => {
  return (
    <div className="space-y-6 md:space-y-7" data-testid="subpage-dashboard">
      {/* Patch v18.0 — banned-account banner (renders null when not flagged). */}
      <BannedBanner me={me} />
      {/* Patch v17.6.1 (2026-07-14) — ProfitStatusBadge temporarily hidden
          from the members' dashboard. Backend sidelining logic remains
          fully active; the /api/me/profit-summary endpoint remains live.
          Re-enable by uncommenting the single JSX line below. */}
      {/* <ProfitStatusBadge onNavigate={onNavigate} /> */}
      <PayoutProofCTA />
      <GettingStartedSection onNavigate={onNavigate} />
      <ProfitBadge me={me} />
      <PositionStatsStrip />
      <AdCreditsCard me={me} />
      <DualWalletCards me={me} />
      <ReferralLinkBox referralCode={me.referral_code} />
    </div>
  );
};

export default DashboardSubpage;
